export default {
  en: {
    TCPA_SHIELD_HISTORY_TABLE_DATE: 'Date',
    TCPA_SHIELD_HISTORY_TABLE_ORIGIN: 'Origin',
    TCPA_SHIELD_HISTORY_TABLE_CHECKED: 'Numbers Checked',
    TCPA_SHIELD_HISTORY_TABLE_SCRUBBED: 'Numbers Scrubed',
    TCPA_SHIELD_HISTORY_TABLE_COST: 'Cost',
    TCPA_SHIELD_HISTORY_TABLE_LOADING: 'Loading History',
    TCPA_SHIELD_HISTORY_TABLE_EMPTY: 'No requests made in the period'
  }
};